const EVENT_HANDLED_MARKER = '__BLAZE_EVENT_HANDLED';

type EventMarker = { [EVENT_HANDLED_MARKER]?: boolean };

export function markEventAsHandled<T extends Event>(event: T): void {
  (event as EventMarker)[EVENT_HANDLED_MARKER] = true;
}

export function wasEventHandled(event: Event & EventMarker): boolean {
  return event[EVENT_HANDLED_MARKER] === true;
}

export function isEventTargetType<T>(event: Event): event is Event & { target: T } {
  return !!event.target && event.target instanceof HTMLElement;
}
